import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { ContaService } from 'src/app/admihair/service/conta.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-operacao-financeira-editar',
  templateUrl: './operacao-financeira-editar.component.html',
  styleUrls: ['./operacao-financeira-editar.component.scss']
})
export class OperacaoFinanceiraEditarComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoEditar: boolean = false;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  exibirSpinner: boolean = false;
  empresaSelecionada?: Empresa;
  progressoRequisicao: boolean = false;
  operacao?: Operacao;
  listaContas: Conta[] = [];

  constructor(private activatedRouter: ActivatedRoute, 
    private operacaoService: OperacaoFinanceiraService,
    private utilStorageService: UtilStorageService,
    private contaService: ContaService,
    private erroService: ErroService) { }



  ngOnInit(): void {
    this.exibirSpinner = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_OPERACAO_FINANCEIRA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarIdOperacao();
    if (this.permissaoEditar) {
      this.carregarDados();
    }
  }

  carregarIdOperacao(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  carregarDados(){
    forkJoin([
      this.contaService.listarPorEmpresa(this.empresaSelecionada?.id),
      this.operacaoService.buscarPorId(this.id)
    ]).subscribe({
      next: ([contas, operacao]) => {
        this.listaContas = contas;
        this.operacao = operacao;
        this.exibirSpinner = false;
        
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      }
    })
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.operacaoService.atualizar(this.operacao, this.id).subscribe({
      next: () => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      }
    });
  }


  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

}
